import {
	CommunityPostCommentNotificationDataViewModel,
	CommunityPostCommentMentionNotificationDataViewModel,
	CommunityPostCommentReactionNotificationDataViewModel
} from "client/Api/Notifications/notifications";
import { CommunityPostDialog } from "client/Features/Hub/Communities/CommunityPostDialog";
import { ReactElement } from "react";

export type CommunityPostCommentInvocationProps = {
	data: CommunityPostCommentNotificationDataViewModel
		| CommunityPostCommentMentionNotificationDataViewModel
		| CommunityPostCommentReactionNotificationDataViewModel;
	onDismiss: () => void;
};

export const CommunityPostCommentInvocation = (
	props: CommunityPostCommentInvocationProps
): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		postId,
		commentId
	} = data;

	return (
		<CommunityPostDialog
			id={postId}
			onClose={onDismiss}
			deepLink={{
				kind: "comment",
				commentId
			}}
		/>
	);
};

CommunityPostCommentInvocation.displayName = "CommunityPostCommentInvocation";